(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-complement"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async event=>{
 const button=event.target.closest('[data-nm-complement-add]');
 if(!button||button.disabled)return;
 const root=button.closest('[data-nm-complement]'),status=root.querySelector('[data-nm-complement-status]');
 const ids=[Number(root.dataset.mainId),Number(root.dataset.partnerId)];
 if(ids.some(id=>!Number.isSafeInteger(id)||id<=0)||ids[0]===ids[1])return;
 button.disabled=true;button.setAttribute('aria-busy','true');status.textContent='';
 try{
  const response=await fetch(root.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});
  if(!response.ok)throw new Error(root.dataset.error);
  const cart=await response.json(),items=ids.filter(id=>!cart.items.some(item=>item.variant_id===id&&item.quantity>0&&!item.selling_plan_allocation)).map(id=>({id,quantity:1}));
  if(items.length){
   const added=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
   const result=await added.json();if(!added.ok)throw new Error(result.description||root.dataset.error);
  }
  location.assign(root.dataset.cartUrl);
 }catch(error){status.textContent=error.message||root.dataset.error;button.disabled=false;button.removeAttribute('aria-busy');}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', async event => {
 const form = event.target;
 const root = form.querySelector('[data-nm-welcome]');
 if (!root) return;
 event.preventDefault();
 event.stopImmediatePropagation();
 if (form.dataset.nmWelcomeBusy === 'true' || !form.reportValidity()) return;
 const email = form.querySelector('input[type="email"]');
 const button = form.querySelector('button[type="submit"]');
 const status = root.querySelector('[data-nm-signup-status]');
 form.dataset.nmWelcomeBusy = 'true';
 button.disabled = true;
 button.setAttribute('aria-busy', 'true');
 status.textContent = root.dataset.sending;
 const controller = new AbortController();
 const timeout = setTimeout(() => controller.abort(), 10000);
 try {
  const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.siteId), {
   method: 'POST', signal: controller.signal,
   headers: {'Content-Type':'application/vnd.api+json', 'Accept':'application/vnd.api+json', 'revision':'2026-07-15'},
   body: JSON.stringify({
    data: {
     type: 'subscription',
     attributes: {
      custom_source: 'NeverMind footer welcome signup',
      profile: {
       data: {
        type: 'profile',
        attributes: {
         email: email.value.trim(),
         subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
        }
       }
      }
     },
     relationships: {list: {data: {type: 'list', id: root.dataset.listId}}}
    }
   })
  });
  if (!response.ok) throw new Error('Signup failed');
  status.textContent = root.dataset.success;
  form.reset();
  try {
   localStorage.setItem('nm-email-subscribed-v1', '1');
   sessionStorage.setItem('nm-signup-reload-path', location.pathname);
  } catch (storageError) {}
  const url = new URL(location.href);
  if (url.hash === '#nm-newsletter' || url.hash === '#contact_form') url.hash = '';
  url.searchParams.delete('customer_posted');
  history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  document.dispatchEvent(new CustomEvent('nm:email-subscribed'));
 } catch (error) {
  status.textContent = root.dataset.error;
  button.disabled = false;
  button.removeAttribute('aria-busy');
 } finally {
  button.disabled = false;
  button.removeAttribute('aria-busy');
  clearTimeout(timeout);
  form.dataset.nmWelcomeBusy = 'false';
 }
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-full-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
 const lead = { '8504888164518': ['21583b6f-6eb2-40e6-ad06-2e3307cbd663','f232e77f-23f0-4f1e-907d-d343bd4efea9'], '8504897536166': ['5aaa1b8f-8f5a-4800-b357-e3b07a13293b'] };
 const apply = () => document.querySelectorAll('#nm-full-reviews .jdgm-review-widget[data-id]').forEach(widget => {
   const ids = lead[widget.dataset.id]; if (!ids) return;
   const reviews = ids.map(id => widget.querySelector('[data-review-id="'+id+'"]')).filter(Boolean);
   if (!reviews.length) return;
   const parent = reviews[0].parentElement;
   if (!reviews.every(review => review.parentElement === parent)) return;
   if (reviews.every((review,i) => parent.children[i] === review)) return;
   reviews.slice().reverse().forEach(review => parent.prepend(review));
 });
 const start = () => { const section=document.getElementById('nm-full-reviews');if(!section)return;apply();new MutationObserver(apply).observe(section,{childList:true,subtree:true}); };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-pair-deals"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-nm-add-pair]');
    if (!button || button.disabled || document.documentElement.dataset.nmPairBusy === 'true') return;
    const section = button.closest('[data-nm-pairs]');
    const status = button.closest('article').querySelector('[data-nm-pair-status]');
    const ids = [Number(button.dataset.firstVariant), Number(button.dataset.secondVariant)];
    if (ids.some(id => !Number.isSafeInteger(id) || id <= 0) || ids[0] === ids[1]) return;
    document.documentElement.dataset.nmPairBusy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      let items = ids.map(id => ({id, quantity: 1}));
      if (section.dataset.completePair === 'true') {
        const cartResponse = await fetch(section.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error(section.dataset.error);
        const cart = await cartResponse.json();
        items = items.filter(item => !cart.items.some(line => line.variant_id === item.id && line.quantity > 0 && !line.selling_plan_allocation));
      }
      if (items.length) {
        const response = await fetch(section.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || section.dataset.error);
        status.textContent = section.dataset.success;
      } else {
        status.textContent = section.dataset.existing;
      }
      window.location.assign(section.dataset.cartUrl);
    } catch (error) {
      status.textContent = error.message || section.dataset.error;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      delete document.documentElement.dataset.nmPairBusy;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-proof-videos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('error', event => {
 const media=event.target;
 const video=media.matches?.('video.nm-proof-videos__player') ? media : media.closest?.('video.nm-proof-videos__player');
 if(!video)return;
 const figure=video.closest('figure'),section=video.closest('.nm-proof-videos');
 if(figure)figure.hidden=true;
 if(section && !section.querySelector('figure:not([hidden])'))section.hidden=true;
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-set-deal"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('click', async event => {
  const button=event.target.closest('[data-nm-add-set]');
  if(!button||button.disabled||document.documentElement.dataset.nmPairBusy==='true')return;
  const section=button.closest('[data-nm-set]'),status=section.querySelector('[data-nm-set-status]');
  const ids=button.dataset.variants.split(',').map(Number);
  if(ids.length!==3||new Set(ids).size!==3||ids.some(id=>!Number.isSafeInteger(id)||id<=0)||!section.dataset.code)return;
  document.documentElement.dataset.nmPairBusy='true';button.disabled=true;button.setAttribute('aria-busy','true');status.textContent='';
  try {
   const response=await fetch(section.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:ids.map(id=>({id,quantity:1}))})});
   const result=await response.json();if(!response.ok)throw new Error(result.description||section.dataset.error);
   const root=window.Shopify?.routes?.root||'/';
   window.location.assign(root+'discount/'+encodeURIComponent(section.dataset.code)+'?redirect='+encodeURIComponent(section.dataset.cartUrl));
  }catch(error){status.textContent=error.message||section.dataset.error;button.disabled=false;button.removeAttribute('aria-busy');delete document.documentElement.dataset.nmPairBusy;}
 });

  } catch(e) { console.error(e); }
})();
})();
